import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const GET_ACCOUNT_PICKUP_DRIVER_BY_ACCOUNT_ID = gql`
    query GetAccountPickupDriverByAccountId($accountId: Long!) {
        getAccountPickupDriverByAccountId(accountId: $accountId) {
            id
            accountId
            warehouseId
            vehicleId
            workWeekdaysJson
            workStartTime
            workEndTime
            responsibleZipcodeListJson
        }
    }
`;

export interface AccountPickupDriverType {
    id: number;
    accountId: number;
    warehouseId: number;
    vehicleId?: number;
    workWeekdaysJson: string;
    workStartTime: string;
    workEndTime: string;
    responsibleZipcodeListJson?: string;
}

interface GetAccountPickupDriverByAccountIdQuery {
    getAccountPickupDriverByAccountId: AccountPickupDriverType;
}

interface GetAccountPickupDriverByAccountIdQueryVariables {
    accountId: number;
}

export const getAccountPickupDriverByAccountId = async (accountId: number): Promise<AccountPickupDriverType> => {
    const {data} = await client.query<GetAccountPickupDriverByAccountIdQuery, GetAccountPickupDriverByAccountIdQueryVariables>({
        query: GET_ACCOUNT_PICKUP_DRIVER_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountPickupDriverByAccountId;
}; 